(function () {
  'use strict';

  // ★/☆の文字列（5段階）
  function stars(n) {
    var r = Math.max(0, Math.min(5, Math.round(Number(n) || 0)));
    return '★'.repeat(r) + '☆'.repeat(5 - r);
  }

  // Shopify の画像URLに幅の指定を付ける（小さく並べる用／大きく出す用）
  function sized(url, width) {
    try {
      var u = new URL(url, location.href);
      if (u.protocol !== 'https:') return '';
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) { return ''; }
  }

  // 押すと大きく出す（もう一度押すか、外側・Escで閉じる）
  function openLarge(url) {
    var src = sized(url, 1600);
    if (!src) return;
    var ov = document.createElement('div');
    ov.className = 'coupon-reviews__overlay';
    ov.setAttribute('data-coupon-reviews-overlay', '1');
    var img = document.createElement('img');
    img.src = src;
    img.alt = '';
    ov.appendChild(img);
    function close() {
      document.removeEventListener('keydown', onKey);
      if (ov.parentNode) ov.parentNode.removeChild(ov);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    ov.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    document.body.appendChild(ov);
  }

  function init() {
    var list = document.querySelector('[data-coupon-reviews-list]');
    if (!list) return;
    // ★平均の差し込み先は、ページ内で最初に見つかった1つだけ使う
    var summary = document.querySelector('[data-coupon-reviews-summary]');
    var base = (list.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    var item = list.getAttribute('data-item') || '';
    if (!base || !item) return;

    fetch(base + '/pub/theme/reviews?item=' + encodeURIComponent(item), {
      method: 'GET',
      credentials: 'omit'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('bad');
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.count || data.average === null || data.average === undefined) return;
        render(summary, list, data);
      })
      .catch(function () { /* 通信失敗時は何も出さない */ });
  }

  function render(summary, list, data) {
    if (summary) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'coupon-reviews__summary';
      btn.textContent = '★' + Number(data.average).toFixed(1) + '（' + data.count + '件）';
      btn.addEventListener('click', function () {
        list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      summary.appendChild(btn);
    }

    var ul = document.createElement('ul');
    ul.className = 'coupon-reviews__list';
    (data.reviews || []).forEach(function (rv) {
      var li = document.createElement('li');
      li.className = 'coupon-reviews__item';

      var head = document.createElement('div');
      head.className = 'coupon-reviews__head';
      var st = document.createElement('span');
      st.className = 'coupon-reviews__stars';
      st.textContent = stars(rv.rating);
      var dt = document.createElement('span');
      dt.className = 'coupon-reviews__date';
      dt.textContent = rv.posted_at || '';
      head.appendChild(st);
      head.appendChild(dt);

      var body = document.createElement('div');
      body.className = 'coupon-reviews__body is-clamped';
      body.textContent = rv.body || '';
      body.addEventListener('click', function () {
        body.classList.toggle('is-clamped');
      });

      li.appendChild(head);
      li.appendChild(body);

      // 本文の下に写真を小さく並べる
      var photos = (rv.photos || []).filter(function (u) { return typeof u === 'string'; });
      if (photos.length) {
        var row = document.createElement('div');
        row.className = 'coupon-reviews__photos';
        photos.forEach(function (u) {
          var thumb = sized(u, 160);
          if (!thumb) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'coupon-reviews__photo';
          var im = document.createElement('img');
          im.src = thumb;
          im.alt = 'レビューの写真';
          im.loading = 'lazy';
          b.appendChild(im);
          b.addEventListener('click', function () { openLarge(u); });
          row.appendChild(b);
        });
        li.appendChild(row);
      }
      ul.appendChild(li);
    });
    list.appendChild(ul);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
